import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { getPageAndFieldValidity, getFirstInvalidPageIdBeforeTheCurrentPageId, PagesAndFields } from './pageValidity';

export const hasSkippedPages = async (
    formConfig: FormConfig,
    formValues: FormValues,
    pageId: string,
    pagesAndFieldsValidity?: PagesAndFields[]
): Promise<string | false> => {
    const _pagesAndFieldsValidity = pagesAndFieldsValidity ?? (await getPageAndFieldValidity(formConfig, formValues));
    const firstInvalidPageId = getFirstInvalidPageIdBeforeTheCurrentPageId(_pagesAndFieldsValidity, pageId);
    if (firstInvalidPageId) {
        return firstInvalidPageId;
    }
    return false;
};
